import ztComponent from './ztTable.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
